/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const addressSchemaData = {
  de: [
    {
      type: 'RADIO_GROUP',
      id: 'usage',
      options: [
        {
          label: 'Privat',
          value: 'home',
        },
        {
          label: 'Geschäftlich',
          value: 'work',
        },
      ],
    },
    {
      type: 'SELECT',
      id: 'country',
      label: 'Land',
      placeholder: 'Land auswählen',
      required: true,
      validators: { required: null },
      errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
      options: [
        {
          label: 'Andorra',
          value: 'AD',
        },
        {
          label: 'Vereinigte Arabische Emirate',
          value: 'AE',
        },
        {
          label: 'Afghanistan',
          value: 'AF',
        },
        {
          label: 'Antigua und Barbuda',
          value: 'AG',
        },
        {
          label: 'Anguilla',
          value: 'AI',
        },
        {
          label: 'Albanien',
          value: 'AL',
        },
        {
          label: 'Armenien',
          value: 'AM',
        },
        {
          label: 'Niederländische Antillen',
          value: 'AN',
        },
        {
          label: 'Angola',
          value: 'AO',
        },
        {
          label: 'Antarktis',
          value: 'AQ',
        },
        {
          label: 'Argentinien',
          value: 'AR',
        },
        {
          label: 'Amerikanisch-Samoa',
          value: 'AS',
        },
        {
          label: 'Österreich',
          value: 'AT',
        },
        {
          label: 'Australien',
          value: 'AU',
        },
        {
          label: 'Aruba',
          value: 'AW',
        },
        {
          label: 'Aserbaidschan',
          value: 'AZ',
        },
        {
          label: 'Bosnien und Herzegowina',
          value: 'BA',
        },
        {
          label: 'Barbados',
          value: 'BB',
        },
        {
          label: 'Bangladesch',
          value: 'BD',
        },
        {
          label: 'Belgien',
          value: 'BE',
        },
        {
          label: 'Burkina Faso',
          value: 'BF',
        },
        {
          label: 'Bulgarien',
          value: 'BG',
        },
        {
          label: 'Bahrain',
          value: 'BH',
        },
        {
          label: 'Burundi',
          value: 'BI',
        },
        {
          label: 'Benin',
          value: 'BJ',
        },
        {
          label: 'Bermuda',
          value: 'BM',
        },
        {
          label: 'Brunei Darussalam',
          value: 'BN',
        },
        {
          label: 'Bolivien',
          value: 'BO',
        },
        {
          label: 'Brasilien',
          value: 'BR',
        },
        {
          label: 'Bahamas',
          value: 'BS',
        },
        {
          label: 'Bhutan',
          value: 'BT',
        },
        {
          label: 'Bouvetinsel',
          value: 'BV',
        },
        {
          label: 'Botsuana',
          value: 'BW',
        },
        {
          label: 'Belarus',
          value: 'BY',
        },
        {
          label: 'Belize',
          value: 'BZ',
        },
        {
          label: 'Kanada',
          value: 'CA',
        },
        {
          label: 'Kokosinseln',
          value: 'CC',
        },
        {
          label: 'Demokratische Republik Kongo',
          value: 'CD',
        },
        {
          label: 'Zentralafrikanische Republik',
          value: 'CF',
        },
        {
          label: 'Kongo',
          value: 'CG',
        },
        {
          label: 'Schweiz',
          value: 'CH',
        },
        {
          label: 'Côte d’Ivoire',
          value: 'CI',
        },
        {
          label: 'Cookinseln',
          value: 'CK',
        },
        {
          label: 'Chile',
          value: 'CL',
        },
        {
          label: 'Kamerun',
          value: 'CM',
        },
        {
          label: 'China',
          value: 'CN',
        },
        {
          label: 'Kolumbien',
          value: 'CO',
        },
        {
          label: 'Costa Rica',
          value: 'CR',
        },
        {
          label: 'Kuba',
          value: 'CU',
        },
        {
          label: 'Kap Verde',
          value: 'CV',
        },
        {
          label: 'Weihnachtsinsel',
          value: 'CX',
        },
        {
          label: 'Zypern',
          value: 'CY',
        },
        {
          label: 'Tschechische Republik',
          value: 'CZ',
        },
        {
          label: 'Deutschland',
          value: 'DE',
        },
        {
          label: 'Dschibuti',
          value: 'DJ',
        },
        {
          label: 'Dänemark',
          value: 'DK',
        },
        {
          label: 'Dominica',
          value: 'DM',
        },
        {
          label: 'Dominikanische Republik',
          value: 'DO',
        },
        {
          label: 'Algerien',
          value: 'DZ',
        },
        {
          label: 'Ecuador',
          value: 'EC',
        },
        {
          label: 'Estland',
          value: 'EE',
        },
        {
          label: 'Ägypten',
          value: 'EG',
        },
        {
          label: 'Westsahara',
          value: 'EH',
        },
        {
          label: 'Eritrea',
          value: 'ER',
        },
        {
          label: 'Spanien',
          value: 'ES',
        },
        {
          label: 'Äthiopien',
          value: 'ET',
        },
        {
          label: 'Finnland',
          value: 'FI',
        },
        {
          label: 'Fidschi',
          value: 'FJ',
        },
        {
          label: 'Falklandinseln',
          value: 'FK',
        },
        {
          label: 'Mikronesien',
          value: 'FM',
        },
        {
          label: 'Färöer',
          value: 'FO',
        },
        {
          label: 'Frankreich',
          value: 'FR',
        },
        {
          label: 'Gabun',
          value: 'GA',
        },
        {
          label: 'Vereinigtes Königreich',
          value: 'GB',
        },
        {
          label: 'Grenada',
          value: 'GD',
        },
        {
          label: 'Georgien',
          value: 'GE',
        },
        {
          label: 'Französisch-Guayana',
          value: 'GF',
        },
        {
          label: 'Guernsey',
          value: 'GG',
        },
        {
          label: 'Ghana',
          value: 'GH',
        },
        {
          label: 'Gibraltar',
          value: 'GI',
        },
        {
          label: 'Grönland',
          value: 'GL',
        },
        {
          label: 'Gambia',
          value: 'GM',
        },
        {
          label: 'Guinea',
          value: 'GN',
        },
        {
          label: 'Guadeloupe',
          value: 'GP',
        },
        {
          label: 'Äquatorialguinea',
          value: 'GQ',
        },
        {
          label: 'Griechenland',
          value: 'GR',
        },
        {
          label: 'Südgeorgien und die Südlichen Sandwichinseln',
          value: 'GS',
        },
        {
          label: 'Guatemala',
          value: 'GT',
        },
        {
          label: 'Guam',
          value: 'GU',
        },
        {
          label: 'Guinea-Bissau',
          value: 'GW',
        },
        {
          label: 'Guyana',
          value: 'GY',
        },
        {
          label: 'Sonderverwaltungszone Hongkong',
          value: 'HK',
        },
        {
          label: 'Heard- und McDonald-Inseln',
          value: 'HM',
        },
        {
          label: 'Honduras',
          value: 'HN',
        },
        {
          label: 'Kroatien',
          value: 'HR',
        },
        {
          label: 'Haiti',
          value: 'HT',
        },
        {
          label: 'Ungarn',
          value: 'HU',
        },
        {
          label: 'Indonesien',
          value: 'ID',
        },
        {
          label: 'Irland',
          value: 'IE',
        },
        {
          label: 'Israel',
          value: 'IL',
        },
        {
          label: 'Isle of Man',
          value: 'IM',
        },
        {
          label: 'Indien',
          value: 'IN',
        },
        {
          label: 'Britisches Territorium im Indischen Ozean',
          value: 'IO',
        },
        {
          label: 'Irak',
          value: 'IQ',
        },
        {
          label: 'Iran',
          value: 'IR',
        },
        {
          label: 'Island',
          value: 'IS',
        },
        {
          label: 'Italien',
          value: 'IT',
        },
        {
          label: 'Jersey',
          value: 'JE',
        },
        {
          label: 'Jamaika',
          value: 'JM',
        },
        {
          label: 'Jordanien',
          value: 'JO',
        },
        {
          label: 'Japan',
          value: 'JP',
        },
        {
          label: 'Kenia',
          value: 'KE',
        },
        {
          label: 'Kirgisistan',
          value: 'KG',
        },
        {
          label: 'Kambodscha',
          value: 'KH',
        },
        {
          label: 'Kiribati',
          value: 'KI',
        },
        {
          label: 'Komoren',
          value: 'KM',
        },
        {
          label: 'St. Kitts und Nevis',
          value: 'KN',
        },
        {
          label: 'Demokratische Volksrepublik Korea',
          value: 'KP',
        },
        {
          label: 'Republik Korea',
          value: 'KR',
        },
        {
          label: 'Kuwait',
          value: 'KW',
        },
        {
          label: 'Kaimaninseln',
          value: 'KY',
        },
        {
          label: 'Kasachstan',
          value: 'KZ',
        },
        {
          label: 'Laos',
          value: 'LA',
        },
        {
          label: 'Libanon',
          value: 'LB',
        },
        {
          label: 'St. Lucia',
          value: 'LC',
        },
        {
          label: 'Liechtenstein',
          value: 'LI',
        },
        {
          label: 'Sri Lanka',
          value: 'LK',
        },
        {
          label: 'Liberia',
          value: 'LR',
        },
        {
          label: 'Lesotho',
          value: 'LS',
        },
        {
          label: 'Litauen',
          value: 'LT',
        },
        {
          label: 'Luxemburg',
          value: 'LU',
        },
        {
          label: 'Lettland',
          value: 'LV',
        },
        {
          label: 'Libyen',
          value: 'LY',
        },
        {
          label: 'Marokko',
          value: 'MA',
        },
        {
          label: 'Monaco',
          value: 'MC',
        },
        {
          label: 'Republik Moldau',
          value: 'MD',
        },
        {
          label: 'Montenegro',
          value: 'ME',
        },
        {
          label: 'Madagaskar',
          value: 'MG',
        },
        {
          label: 'Marshallinseln',
          value: 'MH',
        },
        {
          label: 'Mazedonien',
          value: 'MK',
        },
        {
          label: 'Mali',
          value: 'ML',
        },
        {
          label: 'Myanmar',
          value: 'MM',
        },
        {
          label: 'Mongolei',
          value: 'MN',
        },
        {
          label: 'Sonderverwaltungszone Macao',
          value: 'MO',
        },
        {
          label: 'Nördliche Marianen',
          value: 'MP',
        },
        {
          label: 'Martinique',
          value: 'MQ',
        },
        {
          label: 'Mauretanien',
          value: 'MR',
        },
        {
          label: 'Montserrat',
          value: 'MS',
        },
        {
          label: 'Malta',
          value: 'MT',
        },
        {
          label: 'Mauritius',
          value: 'MU',
        },
        {
          label: 'Malediven',
          value: 'MV',
        },
        {
          label: 'Malawi',
          value: 'MW',
        },
        {
          label: 'Mexiko',
          value: 'MX',
        },
        {
          label: 'Malaysia',
          value: 'MY',
        },
        {
          label: 'Mosambik',
          value: 'MZ',
        },
        {
          label: 'Namibia',
          value: 'NA',
        },
        {
          label: 'Neukaledonien',
          value: 'NC',
        },
        {
          label: 'Niger',
          value: 'NE',
        },
        {
          label: 'Norfolkinsel',
          value: 'NF',
        },
        {
          label: 'Nigeria',
          value: 'NG',
        },
        {
          label: 'Nicaragua',
          value: 'NI',
        },
        {
          label: 'Niederlande',
          value: 'NL',
        },
        {
          label: 'Norwegen',
          value: 'NO',
        },
        {
          label: 'Nepal',
          value: 'NP',
        },
        {
          label: 'Nauru',
          value: 'NR',
        },
        {
          label: 'Niue',
          value: 'NU',
        },
        {
          label: 'Neuseeland',
          value: 'NZ',
        },
        {
          label: 'Oman',
          value: 'OM',
        },
        {
          label: 'Panama',
          value: 'PA',
        },
        {
          label: 'Peru',
          value: 'PE',
        },
        {
          label: 'Französisch-Polynesien',
          value: 'PF',
        },
        {
          label: 'Papua-Neuguinea',
          value: 'PG',
        },
        {
          label: 'Philippinen',
          value: 'PH',
        },
        {
          label: 'Pakistan',
          value: 'PK',
        },
        {
          label: 'Polen',
          value: 'PL',
        },
        {
          label: 'St. Pierre und Miquelon',
          value: 'PM',
        },
        {
          label: 'Pitcairn',
          value: 'PN',
        },
        {
          label: 'Puerto Rico',
          value: 'PR',
        },
        {
          label: 'Palästinensische Gebiete',
          value: 'PS',
        },
        {
          label: 'Portugal',
          value: 'PT',
        },
        {
          label: 'Palau',
          value: 'PW',
        },
        {
          label: 'Paraguay',
          value: 'PY',
        },
        {
          label: 'Katar',
          value: 'QA',
        },
        {
          label: 'Réunion',
          value: 'RE',
        },
        {
          label: 'Rumänien',
          value: 'RO',
        },
        {
          label: 'Serbien',
          value: 'RS',
        },
        {
          label: 'Russische Föderation',
          value: 'RU',
        },
        {
          label: 'Ruanda',
          value: 'RW',
        },
        {
          label: 'Saudi-Arabien',
          value: 'SA',
        },
        {
          label: 'Salomonen',
          value: 'SB',
        },
        {
          label: 'Seychellen',
          value: 'SC',
        },
        {
          label: 'Sudan',
          value: 'SD',
        },
        {
          label: 'Schweden',
          value: 'SE',
        },
        {
          label: 'Singapur',
          value: 'SG',
        },
        {
          label: 'St. Helena',
          value: 'SH',
        },
        {
          label: 'Slowenien',
          value: 'SI',
        },
        {
          label: 'Svalbard und Jan Mayen',
          value: 'SJ',
        },
        {
          label: 'Slowakei',
          value: 'SK',
        },
        {
          label: 'Sierra Leone',
          value: 'SL',
        },
        {
          label: 'San Marino',
          value: 'SM',
        },
        {
          label: 'Senegal',
          value: 'SN',
        },
        {
          label: 'Somalia',
          value: 'SO',
        },
        {
          label: 'Suriname',
          value: 'SR',
        },
        {
          label: 'São Tomé und Príncipe',
          value: 'ST',
        },
        {
          label: 'El Salvador',
          value: 'SV',
        },
        {
          label: 'Syrien',
          value: 'SY',
        },
        {
          label: 'Swasiland',
          value: 'SZ',
        },
        {
          label: 'Turks- und Caicosinseln',
          value: 'TC',
        },
        {
          label: 'Tschad',
          value: 'TD',
        },
        {
          label: 'Französische Süd- und Antarktisgebiete',
          value: 'TF',
        },
        {
          label: 'Togo',
          value: 'TG',
        },
        {
          label: 'Thailand',
          value: 'TH',
        },
        {
          label: 'Tadschikistan',
          value: 'TJ',
        },
        {
          label: 'Tokelau',
          value: 'TK',
        },
        {
          label: 'Osttimor',
          value: 'TL',
        },
        {
          label: 'Turkmenistan',
          value: 'TM',
        },
        {
          label: 'Tunesien',
          value: 'TN',
        },
        {
          label: 'Tonga',
          value: 'TO',
        },
        {
          label: 'Türkei',
          value: 'TR',
        },
        {
          label: 'Trinidad und Tobago',
          value: 'TT',
        },
        {
          label: 'Tuvalu',
          value: 'TV',
        },
        {
          label: 'Taiwan',
          value: 'TW',
        },
        {
          label: 'Tansania',
          value: 'TZ',
        },
        {
          label: 'Ukraine',
          value: 'UA',
        },
        {
          label: 'Uganda',
          value: 'UG',
        },
        {
          label: 'Vereinigte Staaten',
          value: 'US',
        },
        {
          label: 'Uruguay',
          value: 'UY',
        },
        {
          label: 'Usbekistan',
          value: 'UZ',
        },
        {
          label: 'Vatikanstadt',
          value: 'VA',
        },
        {
          label: 'St. Vincent und die Grenadinen',
          value: 'VC',
        },
        {
          label: 'Venezuela',
          value: 'VE',
        },
        {
          label: 'Britische Jungferninseln',
          value: 'VG',
        },
        {
          label: 'Amerikanische Jungferninseln',
          value: 'VI',
        },
        {
          label: 'Vietnam',
          value: 'VN',
        },
        {
          label: 'Vanuatu',
          value: 'VU',
        },
        {
          label: 'Wallis und Futuna',
          value: 'WF',
        },
        {
          label: 'Samoa',
          value: 'WS',
        },
        {
          label: 'Jemen',
          value: 'YE',
        },
        {
          label: 'Mayotte',
          value: 'YT',
        },
        {
          label: 'Südafrika',
          value: 'ZA',
        },
        {
          label: 'Sambia',
          value: 'ZM',
        },
        {
          label: 'Simbabwe',
          value: 'ZW',
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedCompanyGroup',
      group: [
        {
          type: 'INPUT',
          id: 'vatId',
          label: 'Umsatzsteuer-Identifikationsnummer',
          placeholder: 'Umsatzsteuer-Identifikationsnummer',
          maxLength: 255,
          validators: { pattern: '(DE)[0-9]{9}' },
          errorMessages: { pattern: 'Bitte geben Sie eine gültige Umsatzsteuer-Identifikationsnummer ein.' },
        },
        {
          type: 'INPUT',
          id: 'companyName1',
          label: 'Firma',
          placeholder: 'Firma',
          maxLength: 60,
        },
      ],
      relations: [
        {
          match: 'VISIBLE',
          when: [
            {
              id: 'usage',
              value: 'work',
            },
          ],
        },
        {
          match: 'ENABLED',
          when: [
            {
              id: 'usage',
              value: 'work',
            },
          ],
        },
      ],
    },
    {
      type: 'INPUT',
      id: 'coName',
      label: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
      placeholder: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
      maxLength: 40,
    },
    {
      type: 'GROUP',
      id: 'sharedGroupStreet',
      group: [
        {
          type: 'INPUT',
          id: 'street1',
          label: 'Straße',
          placeholder: 'Straße',
          maxLength: 60,
          required: true,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
        {
          type: 'INPUT',
          id: 'houseNumber',
          label: 'Hausnummer',
          placeholder: 'Hausnummer',
          required: true,
          maxLength: 10,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedGroupPostalCode',
      group: [
        {
          type: 'INPUT',
          id: 'postalCode',
          label: 'Postleitzahl',
          placeholder: 'Postleitzahl',
          required: true,
          maxLength: 10,
          validators: {
            required: null,
            pattern: '^(?!\\s)[\\d]{5}$',
          },
          errorMessages: {
            required: 'Dieses Feld ist ein Pflichtfeld.',
            pattern: 'Bitte geben Sie Ihre Postleitzahl im korrekten Format ein.',
          },
        },
        {
          type: 'INPUT',
          id: 'city',
          label: 'Stadt',
          placeholder: 'Stadt',
          required: true,
          maxLength: 40,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
      ],
    },
    {
      type: 'CHECKBOX',
      id: 'isStandard',
      label: 'Dies ist meine bevorzugte Adresse, über die ich kontaktiert werden möchte.',
    },
  ],
  cy: [
    {
      type: 'RADIO_GROUP',
      id: 'usage',
      options: [
        {
          label: 'Privat',
          value: 'home',
        },
        {
          label: 'Geschäftlich',
          value: 'work',
        },
      ],
    },
    {
      type: 'SELECT',
      id: 'country',
      label: 'Land',
      placeholder: 'Land auswählen',
      required: true,
      validators: { required: null },
      errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
      options: [
        {
          label: 'Andorra',
          value: 'AD',
        },
        {
          label: 'Vereinigte Arabische Emirate',
          value: 'AE',
        },
        {
          label: 'Afghanistan',
          value: 'AF',
        },
        {
          label: 'Antigua und Barbuda',
          value: 'AG',
        },
        {
          label: 'Anguilla',
          value: 'AI',
        },
        {
          label: 'Albanien',
          value: 'AL',
        },
        {
          label: 'Armenien',
          value: 'AM',
        },
        {
          label: 'Niederländische Antillen',
          value: 'AN',
        },
        {
          label: 'Angola',
          value: 'AO',
        },
        {
          label: 'Antarktis',
          value: 'AQ',
        },
        {
          label: 'Argentinien',
          value: 'AR',
        },
        {
          label: 'Amerikanisch-Samoa',
          value: 'AS',
        },
        {
          label: 'Österreich',
          value: 'AT',
        },
        {
          label: 'Australien',
          value: 'AU',
        },
        {
          label: 'Aruba',
          value: 'AW',
        },
        {
          label: 'Aserbaidschan',
          value: 'AZ',
        },
        {
          label: 'Bosnien und Herzegowina',
          value: 'BA',
        },
        {
          label: 'Barbados',
          value: 'BB',
        },
        {
          label: 'Bangladesch',
          value: 'BD',
        },
        {
          label: 'Belgien',
          value: 'BE',
        },
        {
          label: 'Burkina Faso',
          value: 'BF',
        },
        {
          label: 'Bulgarien',
          value: 'BG',
        },
        {
          label: 'Bahrain',
          value: 'BH',
        },
        {
          label: 'Burundi',
          value: 'BI',
        },
        {
          label: 'Benin',
          value: 'BJ',
        },
        {
          label: 'Bermuda',
          value: 'BM',
        },
        {
          label: 'Brunei Darussalam',
          value: 'BN',
        },
        {
          label: 'Bolivien',
          value: 'BO',
        },
        {
          label: 'Brasilien',
          value: 'BR',
        },
        {
          label: 'Bahamas',
          value: 'BS',
        },
        {
          label: 'Bhutan',
          value: 'BT',
        },
        {
          label: 'Bouvetinsel',
          value: 'BV',
        },
        {
          label: 'Botsuana',
          value: 'BW',
        },
        {
          label: 'Belarus',
          value: 'BY',
        },
        {
          label: 'Belize',
          value: 'BZ',
        },
        {
          label: 'Kanada',
          value: 'CA',
        },
        {
          label: 'Kokosinseln',
          value: 'CC',
        },
        {
          label: 'Demokratische Republik Kongo',
          value: 'CD',
        },
        {
          label: 'Zentralafrikanische Republik',
          value: 'CF',
        },
        {
          label: 'Kongo',
          value: 'CG',
        },
        {
          label: 'Schweiz',
          value: 'CH',
        },
        {
          label: 'Côte d’Ivoire',
          value: 'CI',
        },
        {
          label: 'Cookinseln',
          value: 'CK',
        },
        {
          label: 'Chile',
          value: 'CL',
        },
        {
          label: 'Kamerun',
          value: 'CM',
        },
        {
          label: 'China',
          value: 'CN',
        },
        {
          label: 'Kolumbien',
          value: 'CO',
        },
        {
          label: 'Costa Rica',
          value: 'CR',
        },
        {
          label: 'Kuba',
          value: 'CU',
        },
        {
          label: 'Kap Verde',
          value: 'CV',
        },
        {
          label: 'Weihnachtsinsel',
          value: 'CX',
        },
        {
          label: 'Zypern',
          value: 'CY',
        },
        {
          label: 'Tschechische Republik',
          value: 'CZ',
        },
        {
          label: 'Deutschland',
          value: 'DE',
        },
        {
          label: 'Dschibuti',
          value: 'DJ',
        },
        {
          label: 'Dänemark',
          value: 'DK',
        },
        {
          label: 'Dominica',
          value: 'DM',
        },
        {
          label: 'Dominikanische Republik',
          value: 'DO',
        },
        {
          label: 'Algerien',
          value: 'DZ',
        },
        {
          label: 'Ecuador',
          value: 'EC',
        },
        {
          label: 'Estland',
          value: 'EE',
        },
        {
          label: 'Ägypten',
          value: 'EG',
        },
        {
          label: 'Westsahara',
          value: 'EH',
        },
        {
          label: 'Eritrea',
          value: 'ER',
        },
        {
          label: 'Spanien',
          value: 'ES',
        },
        {
          label: 'Äthiopien',
          value: 'ET',
        },
        {
          label: 'Finnland',
          value: 'FI',
        },
        {
          label: 'Fidschi',
          value: 'FJ',
        },
        {
          label: 'Falklandinseln',
          value: 'FK',
        },
        {
          label: 'Mikronesien',
          value: 'FM',
        },
        {
          label: 'Färöer',
          value: 'FO',
        },
        {
          label: 'Frankreich',
          value: 'FR',
        },
        {
          label: 'Gabun',
          value: 'GA',
        },
        {
          label: 'Vereinigtes Königreich',
          value: 'GB',
        },
        {
          label: 'Grenada',
          value: 'GD',
        },
        {
          label: 'Georgien',
          value: 'GE',
        },
        {
          label: 'Französisch-Guayana',
          value: 'GF',
        },
        {
          label: 'Guernsey',
          value: 'GG',
        },
        {
          label: 'Ghana',
          value: 'GH',
        },
        {
          label: 'Gibraltar',
          value: 'GI',
        },
        {
          label: 'Grönland',
          value: 'GL',
        },
        {
          label: 'Gambia',
          value: 'GM',
        },
        {
          label: 'Guinea',
          value: 'GN',
        },
        {
          label: 'Guadeloupe',
          value: 'GP',
        },
        {
          label: 'Äquatorialguinea',
          value: 'GQ',
        },
        {
          label: 'Griechenland',
          value: 'GR',
        },
        {
          label: 'Südgeorgien und die Südlichen Sandwichinseln',
          value: 'GS',
        },
        {
          label: 'Guatemala',
          value: 'GT',
        },
        {
          label: 'Guam',
          value: 'GU',
        },
        {
          label: 'Guinea-Bissau',
          value: 'GW',
        },
        {
          label: 'Guyana',
          value: 'GY',
        },
        {
          label: 'Sonderverwaltungszone Hongkong',
          value: 'HK',
        },
        {
          label: 'Heard- und McDonald-Inseln',
          value: 'HM',
        },
        {
          label: 'Honduras',
          value: 'HN',
        },
        {
          label: 'Kroatien',
          value: 'HR',
        },
        {
          label: 'Haiti',
          value: 'HT',
        },
        {
          label: 'Ungarn',
          value: 'HU',
        },
        {
          label: 'Indonesien',
          value: 'ID',
        },
        {
          label: 'Irland',
          value: 'IE',
        },
        {
          label: 'Israel',
          value: 'IL',
        },
        {
          label: 'Isle of Man',
          value: 'IM',
        },
        {
          label: 'Indien',
          value: 'IN',
        },
        {
          label: 'Britisches Territorium im Indischen Ozean',
          value: 'IO',
        },
        {
          label: 'Irak',
          value: 'IQ',
        },
        {
          label: 'Iran',
          value: 'IR',
        },
        {
          label: 'Island',
          value: 'IS',
        },
        {
          label: 'Italien',
          value: 'IT',
        },
        {
          label: 'Jersey',
          value: 'JE',
        },
        {
          label: 'Jamaika',
          value: 'JM',
        },
        {
          label: 'Jordanien',
          value: 'JO',
        },
        {
          label: 'Japan',
          value: 'JP',
        },
        {
          label: 'Kenia',
          value: 'KE',
        },
        {
          label: 'Kirgisistan',
          value: 'KG',
        },
        {
          label: 'Kambodscha',
          value: 'KH',
        },
        {
          label: 'Kiribati',
          value: 'KI',
        },
        {
          label: 'Komoren',
          value: 'KM',
        },
        {
          label: 'St. Kitts und Nevis',
          value: 'KN',
        },
        {
          label: 'Demokratische Volksrepublik Korea',
          value: 'KP',
        },
        {
          label: 'Republik Korea',
          value: 'KR',
        },
        {
          label: 'Kuwait',
          value: 'KW',
        },
        {
          label: 'Kaimaninseln',
          value: 'KY',
        },
        {
          label: 'Kasachstan',
          value: 'KZ',
        },
        {
          label: 'Laos',
          value: 'LA',
        },
        {
          label: 'Libanon',
          value: 'LB',
        },
        {
          label: 'St. Lucia',
          value: 'LC',
        },
        {
          label: 'Liechtenstein',
          value: 'LI',
        },
        {
          label: 'Sri Lanka',
          value: 'LK',
        },
        {
          label: 'Liberia',
          value: 'LR',
        },
        {
          label: 'Lesotho',
          value: 'LS',
        },
        {
          label: 'Litauen',
          value: 'LT',
        },
        {
          label: 'Luxemburg',
          value: 'LU',
        },
        {
          label: 'Lettland',
          value: 'LV',
        },
        {
          label: 'Libyen',
          value: 'LY',
        },
        {
          label: 'Marokko',
          value: 'MA',
        },
        {
          label: 'Monaco',
          value: 'MC',
        },
        {
          label: 'Republik Moldau',
          value: 'MD',
        },
        {
          label: 'Montenegro',
          value: 'ME',
        },
        {
          label: 'Madagaskar',
          value: 'MG',
        },
        {
          label: 'Marshallinseln',
          value: 'MH',
        },
        {
          label: 'Mazedonien',
          value: 'MK',
        },
        {
          label: 'Mali',
          value: 'ML',
        },
        {
          label: 'Myanmar',
          value: 'MM',
        },
        {
          label: 'Mongolei',
          value: 'MN',
        },
        {
          label: 'Sonderverwaltungszone Macao',
          value: 'MO',
        },
        {
          label: 'Nördliche Marianen',
          value: 'MP',
        },
        {
          label: 'Martinique',
          value: 'MQ',
        },
        {
          label: 'Mauretanien',
          value: 'MR',
        },
        {
          label: 'Montserrat',
          value: 'MS',
        },
        {
          label: 'Malta',
          value: 'MT',
        },
        {
          label: 'Mauritius',
          value: 'MU',
        },
        {
          label: 'Malediven',
          value: 'MV',
        },
        {
          label: 'Malawi',
          value: 'MW',
        },
        {
          label: 'Mexiko',
          value: 'MX',
        },
        {
          label: 'Malaysia',
          value: 'MY',
        },
        {
          label: 'Mosambik',
          value: 'MZ',
        },
        {
          label: 'Namibia',
          value: 'NA',
        },
        {
          label: 'Neukaledonien',
          value: 'NC',
        },
        {
          label: 'Niger',
          value: 'NE',
        },
        {
          label: 'Norfolkinsel',
          value: 'NF',
        },
        {
          label: 'Nigeria',
          value: 'NG',
        },
        {
          label: 'Nicaragua',
          value: 'NI',
        },
        {
          label: 'Niederlande',
          value: 'NL',
        },
        {
          label: 'Norwegen',
          value: 'NO',
        },
        {
          label: 'Nepal',
          value: 'NP',
        },
        {
          label: 'Nauru',
          value: 'NR',
        },
        {
          label: 'Niue',
          value: 'NU',
        },
        {
          label: 'Neuseeland',
          value: 'NZ',
        },
        {
          label: 'Oman',
          value: 'OM',
        },
        {
          label: 'Panama',
          value: 'PA',
        },
        {
          label: 'Peru',
          value: 'PE',
        },
        {
          label: 'Französisch-Polynesien',
          value: 'PF',
        },
        {
          label: 'Papua-Neuguinea',
          value: 'PG',
        },
        {
          label: 'Philippinen',
          value: 'PH',
        },
        {
          label: 'Pakistan',
          value: 'PK',
        },
        {
          label: 'Polen',
          value: 'PL',
        },
        {
          label: 'St. Pierre und Miquelon',
          value: 'PM',
        },
        {
          label: 'Pitcairn',
          value: 'PN',
        },
        {
          label: 'Puerto Rico',
          value: 'PR',
        },
        {
          label: 'Palästinensische Gebiete',
          value: 'PS',
        },
        {
          label: 'Portugal',
          value: 'PT',
        },
        {
          label: 'Palau',
          value: 'PW',
        },
        {
          label: 'Paraguay',
          value: 'PY',
        },
        {
          label: 'Katar',
          value: 'QA',
        },
        {
          label: 'Réunion',
          value: 'RE',
        },
        {
          label: 'Rumänien',
          value: 'RO',
        },
        {
          label: 'Serbien',
          value: 'RS',
        },
        {
          label: 'Russische Föderation',
          value: 'RU',
        },
        {
          label: 'Ruanda',
          value: 'RW',
        },
        {
          label: 'Saudi-Arabien',
          value: 'SA',
        },
        {
          label: 'Salomonen',
          value: 'SB',
        },
        {
          label: 'Seychellen',
          value: 'SC',
        },
        {
          label: 'Sudan',
          value: 'SD',
        },
        {
          label: 'Schweden',
          value: 'SE',
        },
        {
          label: 'Singapur',
          value: 'SG',
        },
        {
          label: 'St. Helena',
          value: 'SH',
        },
        {
          label: 'Slowenien',
          value: 'SI',
        },
        {
          label: 'Svalbard und Jan Mayen',
          value: 'SJ',
        },
        {
          label: 'Slowakei',
          value: 'SK',
        },
        {
          label: 'Sierra Leone',
          value: 'SL',
        },
        {
          label: 'San Marino',
          value: 'SM',
        },
        {
          label: 'Senegal',
          value: 'SN',
        },
        {
          label: 'Somalia',
          value: 'SO',
        },
        {
          label: 'Suriname',
          value: 'SR',
        },
        {
          label: 'São Tomé und Príncipe',
          value: 'ST',
        },
        {
          label: 'El Salvador',
          value: 'SV',
        },
        {
          label: 'Syrien',
          value: 'SY',
        },
        {
          label: 'Swasiland',
          value: 'SZ',
        },
        {
          label: 'Turks- und Caicosinseln',
          value: 'TC',
        },
        {
          label: 'Tschad',
          value: 'TD',
        },
        {
          label: 'Französische Süd- und Antarktisgebiete',
          value: 'TF',
        },
        {
          label: 'Togo',
          value: 'TG',
        },
        {
          label: 'Thailand',
          value: 'TH',
        },
        {
          label: 'Tadschikistan',
          value: 'TJ',
        },
        {
          label: 'Tokelau',
          value: 'TK',
        },
        {
          label: 'Osttimor',
          value: 'TL',
        },
        {
          label: 'Turkmenistan',
          value: 'TM',
        },
        {
          label: 'Tunesien',
          value: 'TN',
        },
        {
          label: 'Tonga',
          value: 'TO',
        },
        {
          label: 'Türkei',
          value: 'TR',
        },
        {
          label: 'Trinidad und Tobago',
          value: 'TT',
        },
        {
          label: 'Tuvalu',
          value: 'TV',
        },
        {
          label: 'Taiwan',
          value: 'TW',
        },
        {
          label: 'Tansania',
          value: 'TZ',
        },
        {
          label: 'Ukraine',
          value: 'UA',
        },
        {
          label: 'Uganda',
          value: 'UG',
        },
        {
          label: 'Vereinigte Staaten',
          value: 'US',
        },
        {
          label: 'Uruguay',
          value: 'UY',
        },
        {
          label: 'Usbekistan',
          value: 'UZ',
        },
        {
          label: 'Vatikanstadt',
          value: 'VA',
        },
        {
          label: 'St. Vincent und die Grenadinen',
          value: 'VC',
        },
        {
          label: 'Venezuela',
          value: 'VE',
        },
        {
          label: 'Britische Jungferninseln',
          value: 'VG',
        },
        {
          label: 'Amerikanische Jungferninseln',
          value: 'VI',
        },
        {
          label: 'Vietnam',
          value: 'VN',
        },
        {
          label: 'Vanuatu',
          value: 'VU',
        },
        {
          label: 'Wallis und Futuna',
          value: 'WF',
        },
        {
          label: 'Samoa',
          value: 'WS',
        },
        {
          label: 'Jemen',
          value: 'YE',
        },
        {
          label: 'Mayotte',
          value: 'YT',
        },
        {
          label: 'Südafrika',
          value: 'ZA',
        },
        {
          label: 'Sambia',
          value: 'ZM',
        },
        {
          label: 'Simbabwe',
          value: 'ZW',
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedCompanyGroup',
      group: [
        {
          type: 'INPUT',
          id: 'companyName1',
          label: 'Firma',
          placeholder: 'Firma',
          maxLength: 60,
        },
        {
          type: 'INPUT',
          id: 'coName',
          label: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
          placeholder: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
          maxLength: 40,
        },
        {
          type: 'INPUT',
          id: 'vatId',
          label: 'Umsatzsteuer-Identifikationsnummer',
          placeholder: 'Umsatzsteuer-Identifikationsnummer',
          maxLength: 255,
          validators: { pattern: '(CY)[0-9]{8}L' },
          errorMessages: { pattern: 'Bitte geben Sie eine gültige Umsatzsteuer-Identifikationsnummer ein.' },
        },
      ],
      relations: [
        {
          match: 'VISIBLE',
          when: [
            {
              id: 'usage',
              value: 'work',
            },
          ],
        },
        {
          match: 'ENABLED',
          when: [
            {
              id: 'usage',
              value: 'work',
            },
          ],
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedGroupStreet',
      group: [
        {
          type: 'INPUT',
          id: 'street1',
          label: 'Straße',
          placeholder: 'Straße',
          required: true,
          maxLength: 60,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
        {
          type: 'INPUT',
          id: 'houseNumber',
          label: 'Hausnummer',
          placeholder: 'Hausnummer',
          required: true,
          maxLength: 10,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedGroupPostalCode',
      group: [
        {
          type: 'INPUT',
          id: 'postalCode',
          label: 'Postleitzahl',
          placeholder: 'Postleitzahl',
          required: true,
          maxLength: 10,
          validators: {
            required: null,
            pattern: '^(?!\\s)[\\d]{4}$',
          },
          errorMessages: {
            required: 'Dieses Feld ist ein Pflichtfeld.',
            pattern: 'Bitte geben Sie Ihre Postleitzahl im korrekten Format ein.',
          },
        },
        {
          type: 'INPUT',
          id: 'city',
          label: 'Stadt',
          placeholder: 'Stadt',
          required: true,
          maxLength: 40,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
      ],
    },
    {
      type: 'CHECKBOX',
      id: 'isStandard',
      label: 'Dies ist meine bevorzugte Adresse, über die ich kontaktiert werden möchte.',
    },
  ],
  fr: [
    {
      type: 'RADIO_GROUP',
      id: 'usage',
      options: [
        {
          label: 'Privat',
          value: 'home',
        },
        {
          label: 'Geschäftlich',
          value: 'work',
        },
      ],
    },
    {
      type: 'SELECT',
      id: 'country',
      label: 'Land',
      placeholder: 'Land auswählen',
      required: true,
      validators: { required: null },
      errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
      options: [
        {
          label: 'Andorra',
          value: 'AD',
        },
        {
          label: 'Vereinigte Arabische Emirate',
          value: 'AE',
        },
        {
          label: 'Afghanistan',
          value: 'AF',
        },
        {
          label: 'Antigua und Barbuda',
          value: 'AG',
        },
        {
          label: 'Anguilla',
          value: 'AI',
        },
        {
          label: 'Albanien',
          value: 'AL',
        },
        {
          label: 'Armenien',
          value: 'AM',
        },
        {
          label: 'Niederländische Antillen',
          value: 'AN',
        },
        {
          label: 'Angola',
          value: 'AO',
        },
        {
          label: 'Antarktis',
          value: 'AQ',
        },
        {
          label: 'Argentinien',
          value: 'AR',
        },
        {
          label: 'Amerikanisch-Samoa',
          value: 'AS',
        },
        {
          label: 'Österreich',
          value: 'AT',
        },
        {
          label: 'Australien',
          value: 'AU',
        },
        {
          label: 'Aruba',
          value: 'AW',
        },
        {
          label: 'Aserbaidschan',
          value: 'AZ',
        },
        {
          label: 'Bosnien und Herzegowina',
          value: 'BA',
        },
        {
          label: 'Barbados',
          value: 'BB',
        },
        {
          label: 'Bangladesch',
          value: 'BD',
        },
        {
          label: 'Belgien',
          value: 'BE',
        },
        {
          label: 'Burkina Faso',
          value: 'BF',
        },
        {
          label: 'Bulgarien',
          value: 'BG',
        },
        {
          label: 'Bahrain',
          value: 'BH',
        },
        {
          label: 'Burundi',
          value: 'BI',
        },
        {
          label: 'Benin',
          value: 'BJ',
        },
        {
          label: 'Bermuda',
          value: 'BM',
        },
        {
          label: 'Brunei Darussalam',
          value: 'BN',
        },
        {
          label: 'Bolivien',
          value: 'BO',
        },
        {
          label: 'Brasilien',
          value: 'BR',
        },
        {
          label: 'Bahamas',
          value: 'BS',
        },
        {
          label: 'Bhutan',
          value: 'BT',
        },
        {
          label: 'Bouvetinsel',
          value: 'BV',
        },
        {
          label: 'Botsuana',
          value: 'BW',
        },
        {
          label: 'Belarus',
          value: 'BY',
        },
        {
          label: 'Belize',
          value: 'BZ',
        },
        {
          label: 'Kanada',
          value: 'CA',
        },
        {
          label: 'Kokosinseln',
          value: 'CC',
        },
        {
          label: 'Demokratische Republik Kongo',
          value: 'CD',
        },
        {
          label: 'Zentralafrikanische Republik',
          value: 'CF',
        },
        {
          label: 'Kongo',
          value: 'CG',
        },
        {
          label: 'Schweiz',
          value: 'CH',
        },
        {
          label: 'Côte d’Ivoire',
          value: 'CI',
        },
        {
          label: 'Cookinseln',
          value: 'CK',
        },
        {
          label: 'Chile',
          value: 'CL',
        },
        {
          label: 'Kamerun',
          value: 'CM',
        },
        {
          label: 'China',
          value: 'CN',
        },
        {
          label: 'Kolumbien',
          value: 'CO',
        },
        {
          label: 'Costa Rica',
          value: 'CR',
        },
        {
          label: 'Kuba',
          value: 'CU',
        },
        {
          label: 'Kap Verde',
          value: 'CV',
        },
        {
          label: 'Weihnachtsinsel',
          value: 'CX',
        },
        {
          label: 'Zypern',
          value: 'CY',
        },
        {
          label: 'Tschechische Republik',
          value: 'CZ',
        },
        {
          label: 'Deutschland',
          value: 'DE',
        },
        {
          label: 'Dschibuti',
          value: 'DJ',
        },
        {
          label: 'Dänemark',
          value: 'DK',
        },
        {
          label: 'Dominica',
          value: 'DM',
        },
        {
          label: 'Dominikanische Republik',
          value: 'DO',
        },
        {
          label: 'Algerien',
          value: 'DZ',
        },
        {
          label: 'Ecuador',
          value: 'EC',
        },
        {
          label: 'Estland',
          value: 'EE',
        },
        {
          label: 'Ägypten',
          value: 'EG',
        },
        {
          label: 'Westsahara',
          value: 'EH',
        },
        {
          label: 'Eritrea',
          value: 'ER',
        },
        {
          label: 'Spanien',
          value: 'ES',
        },
        {
          label: 'Äthiopien',
          value: 'ET',
        },
        {
          label: 'Finnland',
          value: 'FI',
        },
        {
          label: 'Fidschi',
          value: 'FJ',
        },
        {
          label: 'Falklandinseln',
          value: 'FK',
        },
        {
          label: 'Mikronesien',
          value: 'FM',
        },
        {
          label: 'Färöer',
          value: 'FO',
        },
        {
          label: 'Frankreich',
          value: 'FR',
        },
        {
          label: 'Gabun',
          value: 'GA',
        },
        {
          label: 'Vereinigtes Königreich',
          value: 'GB',
        },
        {
          label: 'Grenada',
          value: 'GD',
        },
        {
          label: 'Georgien',
          value: 'GE',
        },
        {
          label: 'Französisch-Guayana',
          value: 'GF',
        },
        {
          label: 'Guernsey',
          value: 'GG',
        },
        {
          label: 'Ghana',
          value: 'GH',
        },
        {
          label: 'Gibraltar',
          value: 'GI',
        },
        {
          label: 'Grönland',
          value: 'GL',
        },
        {
          label: 'Gambia',
          value: 'GM',
        },
        {
          label: 'Guinea',
          value: 'GN',
        },
        {
          label: 'Guadeloupe',
          value: 'GP',
        },
        {
          label: 'Äquatorialguinea',
          value: 'GQ',
        },
        {
          label: 'Griechenland',
          value: 'GR',
        },
        {
          label: 'Südgeorgien und die Südlichen Sandwichinseln',
          value: 'GS',
        },
        {
          label: 'Guatemala',
          value: 'GT',
        },
        {
          label: 'Guam',
          value: 'GU',
        },
        {
          label: 'Guinea-Bissau',
          value: 'GW',
        },
        {
          label: 'Guyana',
          value: 'GY',
        },
        {
          label: 'Sonderverwaltungszone Hongkong',
          value: 'HK',
        },
        {
          label: 'Heard- und McDonald-Inseln',
          value: 'HM',
        },
        {
          label: 'Honduras',
          value: 'HN',
        },
        {
          label: 'Kroatien',
          value: 'HR',
        },
        {
          label: 'Haiti',
          value: 'HT',
        },
        {
          label: 'Ungarn',
          value: 'HU',
        },
        {
          label: 'Indonesien',
          value: 'ID',
        },
        {
          label: 'Irland',
          value: 'IE',
        },
        {
          label: 'Israel',
          value: 'IL',
        },
        {
          label: 'Isle of Man',
          value: 'IM',
        },
        {
          label: 'Indien',
          value: 'IN',
        },
        {
          label: 'Britisches Territorium im Indischen Ozean',
          value: 'IO',
        },
        {
          label: 'Irak',
          value: 'IQ',
        },
        {
          label: 'Iran',
          value: 'IR',
        },
        {
          label: 'Island',
          value: 'IS',
        },
        {
          label: 'Italien',
          value: 'IT',
        },
        {
          label: 'Jersey',
          value: 'JE',
        },
        {
          label: 'Jamaika',
          value: 'JM',
        },
        {
          label: 'Jordanien',
          value: 'JO',
        },
        {
          label: 'Japan',
          value: 'JP',
        },
        {
          label: 'Kenia',
          value: 'KE',
        },
        {
          label: 'Kirgisistan',
          value: 'KG',
        },
        {
          label: 'Kambodscha',
          value: 'KH',
        },
        {
          label: 'Kiribati',
          value: 'KI',
        },
        {
          label: 'Komoren',
          value: 'KM',
        },
        {
          label: 'St. Kitts und Nevis',
          value: 'KN',
        },
        {
          label: 'Demokratische Volksrepublik Korea',
          value: 'KP',
        },
        {
          label: 'Republik Korea',
          value: 'KR',
        },
        {
          label: 'Kuwait',
          value: 'KW',
        },
        {
          label: 'Kaimaninseln',
          value: 'KY',
        },
        {
          label: 'Kasachstan',
          value: 'KZ',
        },
        {
          label: 'Laos',
          value: 'LA',
        },
        {
          label: 'Libanon',
          value: 'LB',
        },
        {
          label: 'St. Lucia',
          value: 'LC',
        },
        {
          label: 'Liechtenstein',
          value: 'LI',
        },
        {
          label: 'Sri Lanka',
          value: 'LK',
        },
        {
          label: 'Liberia',
          value: 'LR',
        },
        {
          label: 'Lesotho',
          value: 'LS',
        },
        {
          label: 'Litauen',
          value: 'LT',
        },
        {
          label: 'Luxemburg',
          value: 'LU',
        },
        {
          label: 'Lettland',
          value: 'LV',
        },
        {
          label: 'Libyen',
          value: 'LY',
        },
        {
          label: 'Marokko',
          value: 'MA',
        },
        {
          label: 'Monaco',
          value: 'MC',
        },
        {
          label: 'Republik Moldau',
          value: 'MD',
        },
        {
          label: 'Montenegro',
          value: 'ME',
        },
        {
          label: 'Madagaskar',
          value: 'MG',
        },
        {
          label: 'Marshallinseln',
          value: 'MH',
        },
        {
          label: 'Mazedonien',
          value: 'MK',
        },
        {
          label: 'Mali',
          value: 'ML',
        },
        {
          label: 'Myanmar',
          value: 'MM',
        },
        {
          label: 'Mongolei',
          value: 'MN',
        },
        {
          label: 'Sonderverwaltungszone Macao',
          value: 'MO',
        },
        {
          label: 'Nördliche Marianen',
          value: 'MP',
        },
        {
          label: 'Martinique',
          value: 'MQ',
        },
        {
          label: 'Mauretanien',
          value: 'MR',
        },
        {
          label: 'Montserrat',
          value: 'MS',
        },
        {
          label: 'Malta',
          value: 'MT',
        },
        {
          label: 'Mauritius',
          value: 'MU',
        },
        {
          label: 'Malediven',
          value: 'MV',
        },
        {
          label: 'Malawi',
          value: 'MW',
        },
        {
          label: 'Mexiko',
          value: 'MX',
        },
        {
          label: 'Malaysia',
          value: 'MY',
        },
        {
          label: 'Mosambik',
          value: 'MZ',
        },
        {
          label: 'Namibia',
          value: 'NA',
        },
        {
          label: 'Neukaledonien',
          value: 'NC',
        },
        {
          label: 'Niger',
          value: 'NE',
        },
        {
          label: 'Norfolkinsel',
          value: 'NF',
        },
        {
          label: 'Nigeria',
          value: 'NG',
        },
        {
          label: 'Nicaragua',
          value: 'NI',
        },
        {
          label: 'Niederlande',
          value: 'NL',
        },
        {
          label: 'Norwegen',
          value: 'NO',
        },
        {
          label: 'Nepal',
          value: 'NP',
        },
        {
          label: 'Nauru',
          value: 'NR',
        },
        {
          label: 'Niue',
          value: 'NU',
        },
        {
          label: 'Neuseeland',
          value: 'NZ',
        },
        {
          label: 'Oman',
          value: 'OM',
        },
        {
          label: 'Panama',
          value: 'PA',
        },
        {
          label: 'Peru',
          value: 'PE',
        },
        {
          label: 'Französisch-Polynesien',
          value: 'PF',
        },
        {
          label: 'Papua-Neuguinea',
          value: 'PG',
        },
        {
          label: 'Philippinen',
          value: 'PH',
        },
        {
          label: 'Pakistan',
          value: 'PK',
        },
        {
          label: 'Polen',
          value: 'PL',
        },
        {
          label: 'St. Pierre und Miquelon',
          value: 'PM',
        },
        {
          label: 'Pitcairn',
          value: 'PN',
        },
        {
          label: 'Puerto Rico',
          value: 'PR',
        },
        {
          label: 'Palästinensische Gebiete',
          value: 'PS',
        },
        {
          label: 'Portugal',
          value: 'PT',
        },
        {
          label: 'Palau',
          value: 'PW',
        },
        {
          label: 'Paraguay',
          value: 'PY',
        },
        {
          label: 'Katar',
          value: 'QA',
        },
        {
          label: 'Réunion',
          value: 'RE',
        },
        {
          label: 'Rumänien',
          value: 'RO',
        },
        {
          label: 'Serbien',
          value: 'RS',
        },
        {
          label: 'Russische Föderation',
          value: 'RU',
        },
        {
          label: 'Ruanda',
          value: 'RW',
        },
        {
          label: 'Saudi-Arabien',
          value: 'SA',
        },
        {
          label: 'Salomonen',
          value: 'SB',
        },
        {
          label: 'Seychellen',
          value: 'SC',
        },
        {
          label: 'Sudan',
          value: 'SD',
        },
        {
          label: 'Schweden',
          value: 'SE',
        },
        {
          label: 'Singapur',
          value: 'SG',
        },
        {
          label: 'St. Helena',
          value: 'SH',
        },
        {
          label: 'Slowenien',
          value: 'SI',
        },
        {
          label: 'Svalbard und Jan Mayen',
          value: 'SJ',
        },
        {
          label: 'Slowakei',
          value: 'SK',
        },
        {
          label: 'Sierra Leone',
          value: 'SL',
        },
        {
          label: 'San Marino',
          value: 'SM',
        },
        {
          label: 'Senegal',
          value: 'SN',
        },
        {
          label: 'Somalia',
          value: 'SO',
        },
        {
          label: 'Suriname',
          value: 'SR',
        },
        {
          label: 'São Tomé und Príncipe',
          value: 'ST',
        },
        {
          label: 'El Salvador',
          value: 'SV',
        },
        {
          label: 'Syrien',
          value: 'SY',
        },
        {
          label: 'Swasiland',
          value: 'SZ',
        },
        {
          label: 'Turks- und Caicosinseln',
          value: 'TC',
        },
        {
          label: 'Tschad',
          value: 'TD',
        },
        {
          label: 'Französische Süd- und Antarktisgebiete',
          value: 'TF',
        },
        {
          label: 'Togo',
          value: 'TG',
        },
        {
          label: 'Thailand',
          value: 'TH',
        },
        {
          label: 'Tadschikistan',
          value: 'TJ',
        },
        {
          label: 'Tokelau',
          value: 'TK',
        },
        {
          label: 'Osttimor',
          value: 'TL',
        },
        {
          label: 'Turkmenistan',
          value: 'TM',
        },
        {
          label: 'Tunesien',
          value: 'TN',
        },
        {
          label: 'Tonga',
          value: 'TO',
        },
        {
          label: 'Türkei',
          value: 'TR',
        },
        {
          label: 'Trinidad und Tobago',
          value: 'TT',
        },
        {
          label: 'Tuvalu',
          value: 'TV',
        },
        {
          label: 'Taiwan',
          value: 'TW',
        },
        {
          label: 'Tansania',
          value: 'TZ',
        },
        {
          label: 'Ukraine',
          value: 'UA',
        },
        {
          label: 'Uganda',
          value: 'UG',
        },
        {
          label: 'Vereinigte Staaten',
          value: 'US',
        },
        {
          label: 'Uruguay',
          value: 'UY',
        },
        {
          label: 'Usbekistan',
          value: 'UZ',
        },
        {
          label: 'Vatikanstadt',
          value: 'VA',
        },
        {
          label: 'St. Vincent und die Grenadinen',
          value: 'VC',
        },
        {
          label: 'Venezuela',
          value: 'VE',
        },
        {
          label: 'Britische Jungferninseln',
          value: 'VG',
        },
        {
          label: 'Amerikanische Jungferninseln',
          value: 'VI',
        },
        {
          label: 'Vietnam',
          value: 'VN',
        },
        {
          label: 'Vanuatu',
          value: 'VU',
        },
        {
          label: 'Wallis und Futuna',
          value: 'WF',
        },
        {
          label: 'Samoa',
          value: 'WS',
        },
        {
          label: 'Jemen',
          value: 'YE',
        },
        {
          label: 'Mayotte',
          value: 'YT',
        },
        {
          label: 'Südafrika',
          value: 'ZA',
        },
        {
          label: 'Sambia',
          value: 'ZM',
        },
        {
          label: 'Simbabwe',
          value: 'ZW',
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedCompanyGroup',
      group: [
        {
          type: 'INPUT',
          id: 'vatId',
          label: 'Umsatzsteuer-Identifikationsnummer',
          placeholder: 'Umsatzsteuer-Identifikationsnummer',
          maxLength: 255,
          validators: { pattern: '(FR)[0-9A-Z]{2}[0-9]{9}' },
          errorMessages: { pattern: 'Bitte geben Sie eine gültige Umsatzsteuer-Identifikationsnummer ein.' },
        },
        {
          type: 'INPUT',
          id: 'companyName1',
          label: 'Firma',
          placeholder: 'Firma',
          maxLength: 60,
        },
      ],
      relations: [
        {
          match: 'VISIBLE',
          when: [
            {
              id: 'usage',
              value: 'work',
            },
          ],
        },
        {
          match: 'ENABLED',
          when: [
            {
              id: 'usage',
              value: 'work',
            },
          ],
        },
      ],
    },
    {
      type: 'INPUT',
      id: 'coName',
      label: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
      placeholder: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
      maxLength: 40,
    },
    {
      type: 'GROUP',
      id: 'sharedGroupStreet',
      group: [
        {
          type: 'INPUT',
          id: 'houseNumber',
          label: 'Hausnummer',
          placeholder: 'Hausnummer',
          required: true,
          maxLength: 10,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
        {
          type: 'INPUT',
          id: 'street1',
          label: 'Straße',
          placeholder: 'Straße',
          required: true,
          maxLength: 60,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
      ],
    },
    {
      type: 'GROUP',
      id: 'sharedGroupPostalCode',
      group: [
        {
          type: 'INPUT',
          id: 'postalCode',
          label: 'Postleitzahl',
          placeholder: 'Postleitzahl',
          required: true,
          maxLength: 10,
          validators: {
            required: null,
            pattern: '^(?!\\s)[\\d]{5}$',
          },
          errorMessages: {
            required: 'Dieses Feld ist ein Pflichtfeld.',
            pattern: 'Bitte geben Sie Ihre Postleitzahl im korrekten Format ein.',
          },
        },
        {
          type: 'INPUT',
          id: 'city',
          label: 'Stadt',
          placeholder: 'Stadt',
          required: true,
          maxLength: 40,
          validators: { required: null },
          errorMessages: { required: 'Dieses Feld ist ein Pflichtfeld.' },
        },
      ],
    },
    {
      type: 'CHECKBOX',
      id: 'isStandard',
      label: 'Dies ist meine bevorzugte Adresse, über die ich kontaktiert werden möchte.',
    },
  ],
}

// MENA example (OM, QA, KW, XA, SA, XD): the third-party transfer checkbox declares the legal conditions it accepts.
export const countryChangeSchemaData = {
  om: [
    {
      type: 'CHECKBOX',
      id: 'tac',
      label: 'I accept the <a href="{{tacLink}}" target="_blank">Terms and Conditions</a>.',
      required: true,
      validators: { required: null },
      errorMessages: { required: 'This field is required.' },
    },
    {
      type: 'CHECKBOX',
      id: 'thirdPartyTransferCheck',
      label:
        'I agree to the cross-border transfer of my data as described in the <a href="{{link:DPG}}" target="_blank">Data Privacy Policy</a> and the <a href="{{link:DPP_CONNECT}}" target="_blank">Data Privacy Policy Porsche Connect</a>.',
      legalConditions: ['DPG', 'DPP_CONNECT'],
      required: true,
      validators: { required: null },
      errorMessages: { required: 'This field is required.' },
    },
    {
      type: 'PARAGRAPH',
      id: 'dpg',
      label: 'Information on data processing can be found in our <a href="{{dpgLink}}" target="_blank">Data Privacy Policy</a>.',
    },
  ],
}
